import { useCallback } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";

type AuditAction =
  | "view_assessment"
  | "view_appointments"
  | "view_patient_profile"
  | "view_provider_profile"
  | "book_appointment"
  | "cancel_appointment"
  | "reschedule_appointment"
  | "complete_appointment"
  | "confirm_appointment"
  | "no_show_appointment"
  | "scheduled_appointment"
  | "update_triage"
  | "assign_provider"
  | "update_status"
  | "add_provider_note"
  | "view_assessment_detail"
  | "send_prescription"
  | "draft_prescription"
  | "approve_provider"
  | "reject_provider"
  | "revoke_provider"
  | "reinstate_provider"
  | "nudge_patient_reschedule"
  | "record_consent"
  | "state_licensure_check";

type ResourceType =
  | "health_assessment"
  | "appointment"
  | "profile"
  | "provider_note"
  | "prescription"
  | "provider_credential"
  | "consent"
  | "state_check";

interface AuditEntry {
  action: AuditAction;
  resource_type: ResourceType;
  resource_id?: string;
  metadata?: Record<string, unknown>;
}

export const useAuditLog = () => {
  const { user } = useAuth();

  const logAccess = useCallback(
    async ({ action, resource_type, resource_id, metadata }: AuditEntry) => {
      if (!user) return;
      try {
        await supabase.functions.invoke("log-audit", {
          body: { action, resource_type, resource_id: resource_id ?? null, metadata: metadata ?? {} },
        });
      } catch {
        // Audit logging should never break the app
      }
    },
    [user]
  );

  return { logAccess };
};
